import { calendarGridViewComponent } from './calendar-grid-view.component';

export const calendarGridView = angular
	.module('common.components.calendar', [])
	.run(($templateCache) => {
		'ngInject';
		$templateCache.put('eventGridViewTemplate.html', `
        			<div uib-dropdown-toggle ng-style="detail.style" class="evndot">
                    </div>
                    <div uib-dropdown-menu feature = "Events" permission="View" class="dropdown-menu event-details-modal">
                        <div class="event-title event-detail" ng-style="detail.style">
                            <div class="event-main-heading no-capitalized">
                            
                                <h4>{{detail.name}}</h4>
                                <h5 ng-if="(detail.startDate | date: 'mediumDate') === (detail.endDate | date: 'mediumDate')">{{detail.startDate | date: 'MM/dd/yyyy'}} </h5>
                                <h5 ng-if="(detail.startDate | date: 'mediumDate') !== (detail.endDate | date: 'mediumDate')">{{detail.startDate | date: 'MM/dd/yyyy'}} - {{detail.endDate | date: 'MM/dd/yyyy'}}</h5>
                            </div>
                            <div ng-click="$ctrl._onDetailsClick(detail)" class="evnarr" data-toggle="tooltip" title="View">
                                <i class="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div ng-if="detail.description" class="evnholiDesc">
                            <h3>description</h3>
                            <p>
                                {{detail.description}}
                            </p>
                        </div>
                    </div>
    `);
	})
	.component('calendarGridView', calendarGridViewComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/calendar/calendar-grid-view.module.js